import { render, staticRenderFns } from "./ComButton.vue?vue&type=template&id=6b7d40cf&scoped=true"
import script from "./ComButton.vue?vue&type=script&lang=js"
export * from "./ComButton.vue?vue&type=script&lang=js"
import style0 from "./ComButton.vue?vue&type=style&index=0&id=6b7d40cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d40cf",
  null
  
)

export default component.exports